var path = 'batch/gdprRequest/info/gdprRequestInfo.tpl.html';
var html = "<react-component name='gdpr-details-info' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;